import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, message, Modal } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { DevicesAPI } from 'api/DevicesAPI';
import { useEnsureContext } from 'common/hooks';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import React, { FC } from 'react';
import { useMutation } from 'react-query';

interface GenerateDevicesTokensButtonProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  onGenerate?: () => void;
}

export const GenerateDevicesTokensButton: FC<GenerateDevicesTokensButtonProps> = ({
  onGenerate,
  ...buttonProps
}) => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const [mutate, { isLoading }] = useMutation(DevicesAPI.generateDevicesTokens);
  const intlMessage = useFormatMessage();

  const showConfirm = () =>
    Modal.confirm({
      title: intlMessage({ id: 'devices.generateTokens.confirm' }),
      icon: <ExclamationCircleOutlined />,
      okText: intlMessage({ id: 'yes' }),
      cancelText: intlMessage({ id: 'cancel' }),
      okType: 'primary',
      onOk: () =>
        mutate(bpContext.id, {
          onSuccess: () => {
            message.success(
              intlMessage({ id: 'devices.generateTokens.success' })
            );
            onGenerate && onGenerate();
          },
        }),
    });

  return (
    <Button
      type="primary"
      loading={isLoading}
      onClick={showConfirm}
      {...buttonProps}
    />
  );
};
